import React from 'react';
import { Filter } from 'lucide-react';

/**
 * FilterSummaryChip — compact "which slice am I looking at" pill,
 * designed to sit in a CollapsibleSection's `meta` slot so it stays
 * visible on the collapsed Deep Dives header. Shows the active
 * org/cohort/program selection (defaults are filtered out); falls back
 * to "All data" when nothing is narrowed.
 */
export const FilterSummaryChip = ({ parts = [], testId }) => {
  const clean = parts.filter(Boolean);
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-slate-100 text-slate-600 text-[11px] font-medium ring-1 ring-slate-200"
      data-testid={testId}
      title={clean.length ? `Filtered by ${clean.join(' · ')}` : 'Showing all data'}
    >
      <Filter className="h-3 w-3 text-slate-400 shrink-0" />
      {clean.length ? (
        <>Filtered: <span className="font-semibold text-slate-700">{clean.join(' · ')}</span></>
      ) : (
        'All data'
      )}
    </span>
  );
};

export default FilterSummaryChip;
